import { useQuery } from '@tanstack/react-query';
import type { ComponentProps } from 'react';
import { api } from '@/api/client';
import { Field } from './ui';

/** Vehicle numbers already used on transfers, stock-in lines and gate passes. */
export function useVehicleNumbers(): string[] {
  const { data } = useQuery({
    queryKey: ['inventory', 'vehicles'],
    queryFn: () => api.get('/api/v1/inventory/vehicles'),
  });
  // Only offered, never relied on: anything but a list offers nothing.
  return Array.isArray(data) ? data : [];
}

/**
 * The Vehicle field, offering the vehicle numbers already used on transfers,
 * inward shipments and gate passes. A new number can still be typed; if the
 * list cannot be loaded the field simply works as plain text.
 */
export function VehicleField(props: Omit<ComponentProps<typeof Field>, 'suggestions'>) {
  const vehicles = useVehicleNumbers();
  return <Field {...props} suggestions={vehicles} />;
}
